export default __webpack_public_path__ + "static/media/roles.0cf278db.md";